export const HOME = () => `/home`;
